import React, { useState } from "react";
import PlayerTable from "./PlayerTable";
import PlayerModal from "./PlayerModal";
import "./App.css";

function App() {
  const [players, setPlayers] = useState([
    { id: 1, gamerTag: "Captain_boo", department: "CPE", game: "Call of Duty", rank: "Advanced" },
    { id: 2, gamerTag: "SniperQueen", department: "ECE", game: "Mobile Legends", rank: "Pro" },
    { id: 3, gamerTag: "Shadow", department: "EE", game: "Valorant", rank: "Intermediate"},
    { id: 4, gamerTag: "Neyeus", department: "IE", game: "Valorant", rank: "Intermediate"}

  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleAddData(formData) {
    const newPlayer = {
      id: players.length + 1,
      ...formData
    };
    setPlayers([...players, newPlayer]);
  }

  return (
    <div className="app-container">
      <h1>FAITH COE E-Sports Registration</h1>

      <button
        className="open-btn"
        onClick={() => setIsModalOpen(true)}
      >
        Register Player
      </button>

      <PlayerTable players={players} />

      <PlayerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAddData={handleAddData}
      />
    </div>
  );
}

export default App;